import request from '@/lib/request'

// 发送验证码到WhatsApp
export function sendCodeToWhatsApp (data) {
    return request({
        url: '/cloudhub/crmCustomerInfo/noToken/send/whatsapp',
        method: 'post',
        data: data,
        timeout: 60000 // 60秒
    })
}

// 验证验证码
export function verifyCodeApi(phoneNumber, number) {
    return request({
        url: '/cloudhub/crmCustomerInfo/noToken/check/whatsapp',
        method: 'get',
        params: {
            phoneNumber: phoneNumber,
            number: number
        },
        timeout: 60000 // 60秒
    })
}

/**
 * 提交妈妈的信息
 * @param {Number} data.baby1, // baby1的月龄
 * @param {Number} data.baby2, // baby2的月龄
 * @param {Number} data.baby3, // baby3的月龄
 * @param {Number} data.baby4, // baby4的月龄
 * @param {Number} data.baby5, // baby5的月龄
 * @param {Number} data.babySum, // 宝宝数量
 * @param {string} data.name, // 姓名
 * @param {string} data.phoneNumber, // 手机号
 * @param {string} data.sku1, // sku1
 * @param {string} data.sku2, // sku2
 * @param {string} data.sku3, // sku3
 * @param {string} data.skuSize, // sku size
 */
export function submitMonInformation(data) {
    return request({
        url: '/cloudhub/crmCustomerInfo/noToken',
        method: 'post',
        data: data,
        timeout: 60000 // 60秒
    })
}

/**
 * 检测活动是否有效
 * @param {string} data.account, // account[required]
 * @param {string} data.recordId, // recordId[required]
 * @returns {AxiosPromise}
 */
export function checkActivityValid(data) {
    return request({
        url: '/cloudhub/crmCustomerInfo/noToken/check',
        method: 'get',
        params: data,
        timeout: 60000 // 60秒
    })
}

